import React, { useState, useEffect } from "react";

import "./esimDetailsPage.scss";
import SearchTabs from "../SearchTabs/SearchTabs";
import PlanDetails from "../EsimDetail/PlanDetails";
import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";
import { useLocation } from "react-router-dom";

const EsimDetailsPage = () => {
  const location = useLocation();
  const { selectedPackage } = location.state || {};
  console.log(selectedPackage);

  const [plans, setPlans] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("Regional"); // Local | Regional | Global
  const [selectedArea, setSelectedArea] = useState("Africa"); // Dropdown (e.g., Africa, Europe…)

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setPlans([
        {
          id: 1,
          countries: 43,
          data: "10 GB",
          validity: "29 days",
          price: 30,
          popular: true,
        },
        {
          id: 2,
          countries: 43,
          data: "5 GB",
          validity: "29 days",
          price: 20,
          popular: false,
        },
      ]);
      setIsLoading(false);
    }, 800);
  }, [selectedArea, selectedRegion]);

  return (
    <>
      <Navbar />
      <SearchTabs />

      <PlanDetails selectedPackage={selectedPackage} />
      <Footer />
    </>
  );
};

export default EsimDetailsPage;
